// extracted by mini-css-extract-plugin
export default {"link":"link---rUT7D root---KBiyh","authorityLinkSpinner":"authorityLinkSpinner---awwLr"};